import ApplicantPayments from "./ApplicantPaymentsContainer";

export default ApplicantPayments;
